export const DEFAULT_DATAGRID_PAGE_SIZE = 5;
export const DEFAULT_COLUMN_SIZE = 150;
export const DEFAULT_RECONNECT_TIME_INTERVAL = 2000;
export const SNAPSHOT_CALL_INTERVAL  = 4000;
export const SNAPSHOT_QUANTITY_DEFINTION_TIMEOUT = 10000;
export const SNAPSHOT_STEP_PRICE_CHANGE_TIMEOUT = 15000;
export const PERMITTED_DIFFERENCE_IN_TOOMAN = 1000;

export const LOGIN_PAGE_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const MELTED_CONVERSION_FACTOR = 4.3318;